module.exports = __webpack_public_path__ + "img/forum4.124e5d05.jpg";